import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXXL, spaceL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';
import { Row } from '@xing-com/xing-grid';

export const ContentRow = styled(Row)<{
  $isLoading: boolean;
}>`
  ${({ $isLoading }) => ($isLoading ? 'min-height: 50vh;' : '')};
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;
